import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import NotFound from './pages/NotFound/index.js';
import SignIn from './pages/SignIn/index.js';
import WmsSignIn from './pages/WmsSignIn/index.js';
import WorkstationSignIn from './pages/WorkstationSignIn/index.js';
import ResetPassword from './pages/ResetPassword/index.js';
import OAuthAuthorize from './pages/OAuthAuthorize/index.js';
import Layout from './components/Layout/index.js';

// Routes that render their own full-screen layout and should bypass the
// shared card-style <Layout>.
const LAYOUTLESS_ROUTES = ['/wms/sign-in'];

function App() {
  const location = useLocation();
  // Tolerate a trailing slash (QA serves /wms/sign-in/) so the page still
  // bypasses the card-style <Layout>.
  const bare = LAYOUTLESS_ROUTES.includes(
    location.pathname.replace(/\/+$/, ''),
  );

  const routes = (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/wms/sign-in" element={<WmsSignIn />} />
      <Route
        path="/workstation/:workstation_code/sign-in"
        element={<WorkstationSignIn />}
      />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route
        path="/oauth/authorize/:authorization_key"
        element={<OAuthAuthorize />}
      />
    </Routes>
  );

  return bare ? routes : <Layout>{routes}</Layout>;
}

export default App;
